<template>
  <div class="col">
    <!-- USER HAS NO PHONE OR IS NOT VERIFIED -->
    <div v-if="(hasPhone != true) || (phoneVerified != true)" class="row">
      <div class="col-xs-12">
        <!-- USER HAS NO PHONE -->
        <div v-if="hasPhone === false">
          <p>It looks like we don't have a phone number yet. That's how we link your memories to your EZRelic online account.</p>
          <label>
            Phone:
            <input placeholder="e.g., 8164060051" v-model="newPhone" required />
          </label>
          <button @click="updatePhone()" type="button">Update</button>
        </div>

        <!-- USER HAS PHONE BUT IS NOT VERIFIED -->
        <div v-if="(hasPhone === true) && (phoneVerified != true)">
          <p>It looks like we haven't verified your phone number yet. We need to send a text message to {{currentPhone}} so we can confirm it's you. Then you'll be all set.</p>
          <button @click="verifyPhone()">Verify</button>
          <button @click="showUpdatePhone()">Change Phone</button>
        </div>
      </div>
    </div>
    <!-- ----- USER IS LOGGED IN AND HAS VALIDIFIED PHONE -->
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "VerifyPhone",
  components: {},
  data() {
    return {
      newPhone: null
    };
  },
  methods: {
    updatePhone: async function() {
      await this.$store.dispatch("updatePhone", { newPhone: this.newPhone });
    },
    verifyPhone: async function() {
      await this.$store.dispatch("verifyPhone");
      let smsCode = await prompt("Please input verification code: ");

      await this.$store.dispatch("verifyPhoneCode", smsCode);
    },
    showUpdatePhone: function() {
      this.$store.commit("HAS_PHONE", false);
    }
  },
  computed: {
    ...mapState(["userAttrs"]),
    hasPhone: function() {
      return Boolean(this.userAttrs.attributes.phone_number);
    },

    phoneVerified: function() {
      return this.userAttrs.attributes.phone_number_verified;
    },

    showEvents: function() {
      return this.$store.state.showEvents;
    },

    currentPhone: function() {
      return this.userAttrs.attributes.phone_number;
    }
  }
};
</script>